import { Popconfirm, Table } from 'antd';
import React, { Fragment } from 'react'
import H3Text from '@Uilib/h3Text';
import { Link } from 'react-router-dom/cjs/react-router-dom.min';

const ViewIncomingPaymentLines = ({ selectedPaymentOutgoing, selectPaymentTenant, handleUnLinkPaymentGRN, unlinkIncomingPaymentLoading, handleUnLinkPayment, MONEY }) => {
  const InvoiceColumns = [
    {
      title: '',
      responsive: ['xs'],
      render: (item) => (
        <div className="mobile-list__item">
          <H3Text text={`INVOICE ID - ${item?.invoice_id
            }`} className="mobile-list__item-info" />
          <Link to={`/sales/invoice / view / ${item?.invoice_id} `} target="_blank">
            <H3Text text={`REFERENCE NUMBER: ${item?.invoice_id} `} className="mobile-list__item-number" />
          </Link>
          <H3Text text={`GRN TOTAL - ${MONEY(item?.invoice_grand_total || '0')} `} className="mobile-list__item-info" />
          <H3Text text={`LINKED AMOUNT - ${MONEY(item?.total_linked_amount || 0)})`} className="mobile-list__item-info" />
        </div>
      ),
    },
    {
      title: 'INVOICE #',
      responsive: ['sm', 'md', 'lg', 'xxl'],
      render: (text, record) => (
        <Link to={`/ sales / invoice / view / ${record?.invoice_details?.invoice_id} `} target="_blank">
          <H3Text
            text={(
              <div>
                {`${record?.invoice_details?.invoice_number} `}
                <div className="" />
              </div>
            )}
            className="payment__po_no"
          />
        </Link>
      ),
    },
    {
      title: 'INVOICE TOTAL',
      responsive: ['sm', 'md', 'lg', 'xxl'],
      render: (text, record) => MONEY(record?.invoice_details?.invoice_grand_total || '0'),
    },
    {
      title: 'LINKED AMOUNT',
      responsive: ['sm', 'md', 'lg', 'xxl'],
      render: (text, record) => <Fragment>{MONEY(record?.total_linked_amount || 0)}</Fragment>,
    },
  ];
  const CreditNoteColumns = [
    {
      title: '',
      responsive: ['xs'],
      render: (item) => (
        <div className="mobile-list__item">
          <H3Text text={`INVOICE ID - ${item?.invoice_id
            } `} className="mobile-list__item-info" />
          <Link to={`/ sales / invoice / view / ${item?.invoice_id} `} target="_blank">
            <H3Text text={`REFERENCE NUMBER: ${item?.invoice_id} `} className="mobile-list__item-number" />
          </Link>
          <H3Text text={`GRN TOTAL - ${MONEY(item?.invoice_grand_total || '0')} `} className="mobile-list__item-info" />
          <H3Text text={`LINKED AMOUNT - ${MONEY(item?.total_linked_amount || 0)})`} className="mobile-list__item-info" />
        </div>
      ),
    },
    {
      title: 'CREDIT #',
      responsive: ['sm', 'md', 'lg', 'xxl'],
      render: (text, record) => (
        <Link to={`/ sales / invoice / view / ${record?.credit_note_details?.cn_id} `} target="_blank">
          <H3Text
            text={(
              <div>
                {`${record?.credit_note_details?.credit_note_number} `}
                <div className="" />
              </div>
            )}
            className="payment__po_no"
          />
        </Link>
      ),
    },
    {
      title: 'CREDIT NOTE TOTAL',
      responsive: ['sm', 'md', 'lg', 'xxl'],
      render: (text, record) => MONEY(record?.credit_note_details?.cn_grand_total || '0'),
    },
    {
      title: 'LINKED AMOUNT',
      responsive: ['sm', 'md', 'lg', 'xxl'],
      render: (text, record) => <Fragment>{MONEY(record?.total_linked_amount || 0)}</Fragment>,
    },
  ];
  const DebitNoteColumns = [
    {
      title: '',
      responsive: ['xs'],
      render: (item) => (
        <div className="mobile-list__item">
          <H3Text text={`DEBIT NOTE ID - ${item?.debit_note_details?.dn_id} `} className="mobile-list__item-info" />
          <Link to={`/ purchase / debit - note / view / ${item?.debit_note_details?.dn_id} `} target="_blank">
            <H3Text text={`REFERENCE NUMBER: ${item?.debit_note_details?.debit_note_number} `} className="mobile-list__item-number" />
          </Link>
          <H3Text text={`GRN TOTAL - ${MONEY(item?.debit_note_details?.dn_grand_total || '0')} `} className="mobile-list__item-info" />
          <H3Text text={`LINKED AMOUNT - ${MONEY(item?.total_linked_amount || 0)})`} className="mobile-list__item-info" />
        </div>
      ),
    },
    {
      title: 'DEBIT NOTE #',
      responsive: ['sm', 'md', 'lg', 'xxl'],
      render: (text, record) => (
        <Link to={`/ purchase / debit - note / view / ${record?.debit_note_details?.dn_id} `} target="_blank">
          <H3Text
            text={(
              <div>
                {`${record?.debit_note_details?.debit_note_number} `}
                <div className="" />
              </div>
            )}
            className="payment__po_no"
          />
        </Link>
      ),
    },
    {
      title: 'DEBIT NOTE TOTAL',
      responsive: ['sm', 'md', 'lg', 'xxl'],
      render: (text, record) => MONEY(record?.debit_note_details?.dn_grand_total || '0'),
    },
    {
      title: 'LINKED AMOUNT',
      responsive: ['sm', 'md', 'lg', 'xxl'],
      render: (text, record) => <Fragment>{MONEY(record?.total_linked_amount || 0)}</Fragment>,
    },
  ];
  return (
    <div>
      {((selectedPaymentOutgoing?.payment_type === 'INCOMING' && selectedPaymentOutgoing?.linked_invoices?.length) || selectedPaymentOutgoing?.customer_id) && (
        <Table
          bordered
          showHeader
          title={() => `LINKED INVOICES (${selectedPaymentOutgoing?.linked_invoices?.length || '0'})`}
          size="small"
          columns={selectPaymentTenant ? InvoiceColumns : [...InvoiceColumns, {
            title: '',
            responsive: ['sm', 'md', 'lg', 'xxl'],
            render: (record) => (
              <Fragment>
                {(!selectedPaymentOutgoing?.zoho_account_id && !selectedPaymentOutgoing?.tally_bill_payment_number && !selectedPaymentOutgoing?.shopify_transaction_id) ? (
                  <Popconfirm
                    placement="topRight"
                    title="Are you sure to unlink this payment? It will added back to as unused credits for this customer"
                    onConfirm={() => handleUnLinkPayment(record?.invoice_details?.invoice_payments?.[0]?.invoice_payment_id)}
                    okText="Yes"
                    cancelText="No"
                  >
                    <div className="payment-unlink-button">
                      Unlink Payment
                    </div>
                  </Popconfirm>
                ) : <H3Text text="Payments imported from Tally/Zoho/Shopify cannot be updated" />}
              </Fragment>
            ),
          }]}
          dataSource={selectedPaymentOutgoing?.linked_invoices || []}
          pagination={false}
          scroll={{ x: true }}
          loading={unlinkIncomingPaymentLoading}
        />
      )}
      {((selectedPaymentOutgoing?.payment_type === 'INCOMING' && selectedPaymentOutgoing?.linked_debit_notes?.length) || selectedPaymentOutgoing?.tenant_seller_id) && (
        <Table
          bordered
          showHeader
          title={() => `LINKED DEBIT NOTES (${selectedPaymentOutgoing?.linked_debit_notes?.length || '0'})`}
          size="small"
          columns={selectPaymentTenant ? DebitNoteColumns : [...DebitNoteColumns, {
            title: '',
            responsive: ['sm', 'md', 'lg', 'xxl'],
            render: (record) => (
              <Fragment>
                {(!selectedPaymentOutgoing?.zoho_account_id && !selectedPaymentOutgoing?.tally_bill_payment_number && !selectedPaymentOutgoing?.shopify_transaction_id) ? (
                  <Popconfirm
                    placement="topRight"
                    title="Are you sure to unlink this payment? It will added back to as unused credits for this customer"
                    onConfirm={() => handleUnLinkPayment(record?.debit_note_details?.debit_note_payments?.[0]?.invoice_payment_id)}
                    okText="Yes"
                    cancelText="No"
                  >
                    <div className="payment-unlink-button">
                      Unlink Payment
                    </div>
                  </Popconfirm>
                ) : <H3Text text="Payments imported from Tally/Zoho/Shopify cannot be updated" />}
              </Fragment>
            ),
          }]}
          dataSource={selectedPaymentOutgoing?.linked_debit_notes || []}
          pagination={false}
          scroll={{ x: true }}
          loading={unlinkIncomingPaymentLoading}
        />
      )}
      {((selectedPaymentOutgoing?.payment_type === 'OUTGOING' && selectedPaymentOutgoing?.linked_credit_notes?.length) || (selectedPaymentOutgoing?.payment_type === 'OUTGOING' && selectedPaymentOutgoing?.customer_id)) && (
        <Table
          bordered
          showHeader
          title={() => `LINKED CREDIT NOTE (${selectedPaymentOutgoing?.linked_credit_notes?.length || '0'})`}
          size="small"
          columns={selectPaymentTenant ? CreditNoteColumns : [...CreditNoteColumns, {
            title: '',
            responsive: ['sm', 'md', 'lg', 'xxl'],
            render: (record) => (
              <Fragment>
                {(!selectedPaymentOutgoing?.zoho_account_id && !selectedPaymentOutgoing?.tally_bill_payment_number && !selectedPaymentOutgoing?.shopify_transaction_id) ? (
                  <Popconfirm
                    placement="topRight"
                    title="Are you sure to unlink this payment? It will added back to as unused credits for this customer"
                    onConfirm={() => handleUnLinkPaymentGRN(record?.credit_note_details?.credit_note_payments?.[0]?.grn_payment_id)}
                    okText="Yes"
                    cancelText="No"
                  >
                    <div className="payment-unlink-button">
                      Unlink Payment
                    </div>
                  </Popconfirm>
                ) : <H3Text text="Payments imported from Tally/Zoho/Shopify cannot be updated" />}
              </Fragment>
            ),
          }]}
          dataSource={selectedPaymentOutgoing?.linked_credit_notes || []}
          pagination={false}
          scroll={{ x: true }}
          loading={unlinkIncomingPaymentLoading}
        />
      )}
    </div>
  )
}

export default ViewIncomingPaymentLines